import type SceneControl from '../scene/scene'

const useSubComposerFrame = (sceneControl: SceneControl, cb: () => void) => {
  sceneControl.context.addSubComposerFrameRender(cb)
  return () => sceneControl.context.removeSubComposerFrameRender(cb)
}

export default useSubComposerFrame
